import React from 'react';

import './style.scss';

const LanguageInputs = (
    {
        lang,
        title,
        titleMore,
        description,
        descMore,
        feedback,
        feedbackMore,
        feedback2,
        feedback2More,
        handleChange,
        values
    }) => (
    <div className="languageRow">
        <div className="title">
            <label htmlFor={lang + 'Title'}>{titleMore}<span>*</span> </label>
            <input
                id={lang + 'Title'}
                type="text"
                name={lang + 'Title'}
                placeholder={title}
                onChange={handleChange}
                value={values[lang + 'Title']}
            />
        </div>
        <div className="description">
            <label htmlFor={lang + 'Description'}>{descMore}<span>*</span></label>
            <textarea
                id={lang + 'Description'}
                name={lang + 'Description'}
                placeholder={description}
                onChange={handleChange}
                value={values[lang + 'Description']}
            />
        </div>
        <div className="feedback">
            <label htmlFor={lang + 'Feedback'}>{feedbackMore}</label>
            <textarea
                id={lang + 'Feedback'}
                name={lang + 'Feedback'}
                placeholder={feedback}
                onChange={handleChange}
                value={values[lang + 'Feedback']}
            />
        </div>
        <div className="feedback2">
            <label htmlFor={lang + 'Feedback2'}>{feedback2More}</label>
            <textarea
                id={lang + 'Feedback2'}
                name={lang + 'Feedback2'}
                placeholder={feedback2}
                onChange={handleChange}
                value={values[lang + 'Feedback2']}
            />
        </div>
    </div>
);

export default LanguageInputs;
